import React, { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import NotificationBell from '../feed/components/NotificationBell';
import useAuthStore from '../stores/authStore';
import './Header.css';

const Header = ({ darkMode, setDarkMode }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated, signout } = useAuthStore();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleSignOut = () => {
    signout();
    navigate('/signin');
  };

  const handleNavClick = (path) => {
    navigate(path);
    setShowMobileMenu(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="header-title-link">
          <img className='header-logo' src='co-founder.png' alt="CofounderHubs logo" />
          <h1 className="header-title">CofounderHubs</h1>
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="header-nav desktop-nav">
          <NavLink 
            to="/" 
            end
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Home
          </NavLink>
          <NavLink 
            to="/search" 
            end
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Search
          </NavLink>
          <NavLink 
            to="/feed"
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Feed
          </NavLink>
          <NavLink 
            to="/about"
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            About
          </NavLink>
          <NavLink 
            to="/help"
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Help
          </NavLink>
          <NavLink 
            to="/careers"
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Careers
          </NavLink>
        </nav>
        
        {/* Mobile Navigation Dropdown */}
        {showMobileMenu && (
          <nav className="header-nav mobile-nav">
            <button 
              className="mobile-nav-item"
              onClick={() => handleNavClick('/')}
            >
              Home
            </button>
            <button 
              className="mobile-nav-item"
              onClick={() => handleNavClick('/search')}
            >
              Search
            </button>
            <button 
              className="mobile-nav-item"
              onClick={() => handleNavClick('/feed')}
            >
              Feed
            </button>
            <button 
              className="mobile-nav-item"
              onClick={() => handleNavClick('/about')}
            >
              About
            </button>
            <button 
              className="mobile-nav-item"
              onClick={() => handleNavClick('/help')}
            >
              Help
            </button>
            <button 
              className="mobile-nav-item"
              onClick={() => handleNavClick('/careers')}
            >
              Careers
            </button>
          </nav>
        )}
        

        <div className="header-controls">
          {isAuthenticated() ? (
            <>
              <div className="user-menu">
                <img 
                  src={user?.avatar_url || '/img/user-man.png'} 
                  alt={user?.username}
                  className="user-avatar"
                />
                <div className="user-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-username">{user?.username}</div>
                    <div className="dropdown-level">Level {user?.level || 0}</div>
                  </div>
                  <div className="dropdown-divider"></div>
                  <button 
                    className="dropdown-item"
                    onClick={() => navigate('/profile')}
                  >
                    Profile Settings
                  </button>
                  <button 
                    className="dropdown-item"
                    onClick={() => navigate('/connections')}
                  >
                    My Network
                  </button>
                  <button 
                    className="dropdown-item"
                    onClick={() => navigate('/profile#upgrade-level')}
                  >
                    Upgrade Level
                  </button>
                  <div className="dropdown-divider"></div>
                  <button className="dropdown-item" onClick={handleSignOut}>
                    Sign Out
                  </button>
                </div>
              </div>
              <NotificationBell />
            </>
          ) : (
            <>
              <NavLink 
                to="/signin"
                className={({ isActive }) => `nav-link auth ${isActive ? 'active' : ''}`}
              >
                Login
              </NavLink>
              <NavLink 
                to="/signup"
                className={({ isActive }) => `nav-link auth ${isActive ? 'active' : ''}`}
              >
                Register
              </NavLink>
            </>
          )}

          <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
          
          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            aria-label="Toggle menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;